import App from './App.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueLocalStorage from 'vue-localstorage'
import BootstrapVue from "bootstrap-vue";
import Notifications from 'vue-notification'
import vSelect from "vue-select";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './plugins/bootstrap-vue'
import '@/assets/css/app.scss';
import * as Keycloak from "keycloak-js";

Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(VueLocalStorage);
Vue.use(Notifications)
Vue.component("v-select", vSelect);
Vue.config.productionTip = false;

const router = new VueRouter({
  mode: 'history'
});

let initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL, realm: 'agents', clientId: 'agency-portal', onLoad: 'check-sso',
}

let keycloak = Keycloak(initOptions);

keycloak.init({ onLoad: initOptions.onLoad }).success((auth) => {
  if (!auth) {
    router.push('/');
  } else {
    handleAuthenticationSuccess(keycloak);
    setupTokenRefresh(keycloak);
  }

  var vm = new Vue({
    router,
    render: h => h(App, {props: {keycloak: keycloak}})
  });

  vm.$mount('#app');

}).error(() =>{
  console.error("Authenticated Failed");
});

Vue.prototype.$keycloak = keycloak;

function handleAuthenticationSuccess(keycloak) {
  localStorage.setItem('token', keycloak.token);
  localStorage.setItem('logged', true);

  const agency = localStorage.getItem('agency');
  const email = localStorage.getItem('email');

  if (agency && email && keycloak.idTokenParsed && (keycloak.idTokenParsed.email !== email)) {
    localStorage.removeItem('agency');
  }
}

function setupTokenRefresh(keycloak) {
  const timeout = (keycloak.tokenParsed.exp - keycloak.tokenParsed.iat - 3) * 1000;
  setInterval(() => {
    keycloak.updateToken(70).success((refreshed) => {
      if (refreshed) {
        console.log('Token refreshed: ' + refreshed);
      } else {
        console.log('Token not refreshed, valid for: '
            + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    }).error(() =>{
      console.error("Authenticated Failed");
    });
  }, timeout);
}
